module.exports = __webpack_public_path__ + "img/multipolygon.a1c3f4bb.png";